import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sellerService } from "../../services/enhancedCrudService";
import "./success.css";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkSubscriptionStatus = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await sellerService.getProfile();
      if (response && response.data && response.data.subscription_status) {
        const currentUser = JSON.parse(sessionStorage.getItem("user"));
        if (currentUser) {
          currentUser.seller_profile.subscription_status = true;
          sessionStorage.setItem("user", JSON.stringify(currentUser));
        }
      } else {
        setError("No seller profile found");
      }
    } catch (error) {
      setError("Failed to verify subscription status. Please contact support.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToProfile = () => {
    window.location.replace("/sellers/profile");
  };

  const handleGoToSubscription = () => {
    navigate("/subscription");
  };

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  if (error) {
    return (
      <div className="content container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="card">
              <div className="card-body text-center">
                <div className="mb-4">
                  <div className="error-icon-wrapper">
                    <i
                      className="fe fe-alert-triangle text-danger"
                      style={{ fontSize: "4rem" }}
                    ></i>
                  </div>
                </div>
                <h2 className="text-danger mb-3">
                  Subscription Verification Failed
                </h2>
                <p className="text-muted mb-4">{error}</p>
                <div className="d-flex gap-3 justify-content-center">
                  <button
                    className="btn btn-primary"
                    onClick={handleGoToSubscription}
                  >
                    <i className="fe fe-credit-card me-2"></i>
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="content container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="card">
              <div className="card-body text-center">
                <div className="mb-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
                <h4>Verifying subscription status...</h4>
                <p className="text-muted">
                  Please wait while we confirm your subscription.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content container-fluid">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="card success-card">
            <div className="card-body text-center">
              <div className="mb-4">
                <div className="success-icon-wrapper">
                  <i
                    className="fe fe-check-circle text-success"
                    style={{ fontSize: "4rem" }}
                  ></i>
                </div>
              </div>
              <h2 className="text-success mb-3">Payment Successful!</h2>
              <p className="text-muted mb-4">
                Your subscription has been activated successfully. You now have
                access to all premium features.
              </p>
              <div className="d-flex gap-3 justify-content-center action-buttons">
                <button
                  className="btn btn-primary"
                  onClick={handleGoToProfile}
                >
                  <i className="fe fe-home me-2"></i>
                  Go to Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
